import { render, staticRenderFns, recyclableRender, components } from "./priceFormat.vue?vue&type=template&id=151981c5&scoped=true&"
var renderjs
import script from "./priceFormat.vue?vue&type=script&lang=js&"
export * from "./priceFormat.vue?vue&type=script&lang=js&"
import style0 from "./priceFormat.vue?vue&type=style&index=0&id=151981c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151981c5",
  null,
  false,
  components,
  renderjs
)

export default component.exports